<div class="left-text" *ngIf="text" translate>{{text}}</div>
<div class="flex-container">
  <ng-content></ng-content>
</div>
